import { useState, useEffect } from "preact/hooks";

import { CircularProgress } from "@mui/material";

const DebouncedProgress = ({ debounceTime = 500, value, ...props }) => {
  const [state, setState] = useState(false);
  const [timeout, setTimeout] = useState(null);

  useEffect(() => {
    if (value === state) return;

    if (value === true) {
      if (timeout) window.clearTimeout(timeout);
      return setState(value);
    }

    // value === false
    const t = window.setTimeout(() => setState(value), debounceTime);
    return setTimeout(t);
  }, [timeout, state, value]);

  return <>{state && <CircularProgress {...props} />}</>;
};

export default DebouncedProgress;
